import {useNavigate} from 'react-router-dom';
import Sidebar from 'components/sidebar';
import {
  getStoredUserData,
  getUserSession,
  isAdmin,
  isAuthenticated,
  isDriver,
} from 'utils/utils';
import Spinner from 'components/spinner';
import {FocusEvent, ChangeEvent, useEffect, useState} from 'react';
import {ApiClient} from 'utils/apiclient';
import {
  Fundcode,
  IFuelRequest,
  IProjectDetail,
  ISelectOption,
  ISupplier,
  IUser,
  IUserData,
  User,
  Vehicle,
} from 'utils/types';
import {Formik} from 'formik';
import * as yup from 'yup';
import {RequestService} from 'utils/services/request.service';
import {toast, ToastContainer} from 'react-toastify';
import TopStrip from 'components/top_strip';
import SupplierForm from 'modules/settings/supplier_form';
import Select, {SingleValue} from 'react-select';

const FuelRequestForm = (_props: any) => {
  const session = getUserSession();
  const apiClient = new ApiClient(session?.accessToken);
  const requestService = new RequestService(apiClient);
  const userData = getStoredUserData();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestors, setRequestors] = useState<User[]>([]);
  const [fRequestors, setFRequestors] = useState<User[]>();
  const [projects, setProjects] = useState<IProjectDetail[]>([]);
  const [fundcodes, setFundcodes] = useState<Fundcode[]>([]);
  const [activities, setActivities] = useState<string[]>([]);
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [fVehicles, setFVehicles] = useState<Vehicle[]>([]);
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle>();
  const [selectedProject, setSelectedProject] = useState<IProjectDetail>();
  const [selectedFundcode, setSelectedFundcode] = useState<Fundcode>();
  const [selectedDriver, setSelectedDriver] = useState<User | null >();
  const [suppliers, setSuppliers] = useState<ISupplier[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedSupplier, setSelectedSupplier] = useState<ISupplier | null>(
    null
  );

  const isUserAdmin = isAdmin(userData);

  const loadVehiclesAndDrivers = async () => {
    let drivers: User[] = [];
    const vehicles = await apiClient.getAvailableVehiclesForRefuel();
    console.log('🚀 ~ loadVehiclesAndDrivers ~ vehicles:', vehicles);
      if (isUserAdmin) drivers = await apiClient.getActiveDrivers();
      else drivers = [userData as User];
    const driver = drivers[0]
    setRequestors(drivers);
    setFRequestors(drivers);
    setVehicles(vehicles);
    setFVehicles(vehicles);

    setSelectedDriver(driver);
    loadSuppliers(driver);
  };

  const loadProjects = async () => {
    let result = [];
    let projects = await apiClient.getAllProjects();
    if (projects && projects.status == 200) {
      result = projects.data.projects;
    }
    setProjects(result);
    if (result.length > 0) {
      loadFundcodes(result[0].code);
    }
  };
  const loadSuppliers = async (
    user: User | IUser | IUserData | null | undefined
  ) => {
    let data = {
      location: user && user.location ? user.location : null,
    };
    const axios = await apiClient.getSuppliers(data);
    setSuppliers(axios.data.suppliers);
  };
  const handleFundcodeChange = (e: SingleValue<ISelectOption>) => {
    const code = e?.value;
    const fundcode = fundcodes.find((f: Fundcode) => f.code == code);
    setSelectedFundcode(fundcode);
    setActivities(fundcode?.activities!!);
  };
  const loadFundcodes = async (projectCode: string) => {
    setFundcodes([]);
    setSelectedFundcode(undefined);
    setActivities([]);
    let result = [];
    const fundcodes = await apiClient.getProjectFundcodes(projectCode);
    if (fundcodes && fundcodes.status == 200) {
      result = fundcodes.data.fundcodes;
    }
    setFundcodes(result);
    setActivities(result.length > 0 ? result[0].activities : []);
  };

  const loadData = async () => {
    Promise.all([loadProjects(), loadVehiclesAndDrivers()]);
  };
  const handleProjectChange = (option: SingleValue<ISelectOption> | null) => {
    if (option) {
      setSelectedProject(projects.find((p) => p.code == option.value));
      loadFundcodes(option.value as string);
    } else setFundcodes([]);
  };
  const handleDriverSelect = (e: SingleValue<ISelectOption>) => {
    const driver = requestors.find((u: User) => u.id == Number(e?.value));
    const filterVehicles = vehicles; //.filter((v: Vehicle) => v.location == driver?.location)
    setSelectedDriver(driver);
    setFVehicles(filterVehicles);
  };
  const handleVehicleChange = (option: SingleValue<ISelectOption>) => {
    const vehicle = vehicles.find((v: Vehicle) => v.id == option?.value);
    setSelectedVehicle(vehicle);
  };
  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    const input = document.activeElement as unknown as HTMLInputElement;
    input.type = 'date';
  };
  //validation schema
  const formValidationSchema = yup.object({
    // vehicle: yup.string().required('Please select a vehicle'),
    supplier: yup.string().required(),
    price: yup.number().required('Please enter price'),
    quantity: yup.number().required('Please enter quantity'),
    required_date: yup.date().required('Please provide required date'),
    // project: yup.string().required(),
    // fundcode: yup.string().required(),
  });
  const formHandler = async (values: any) => {
    const keys: string[] = Object.keys(values);
    const activities: string[] = keys
      .filter((key: string) => key.includes('cb'))
      .map((key: string) => key.substring(2));
    let start_time = `${values.required_date} ${
      values.start_time ? values.start_time + ':00' : '00:00:00'
    }`;

    const data: IFuelRequest = {
      ...values,
      requestor: selectedDriver?.id,
      activity: activities.join(','),
      requestType: 1,
      admin: selectedDriver?.department_detail?.admin,
      approver: selectedProject?.coordinator,
      mileage: selectedVehicle?.current_mileage,
      start_time: Date.parse(start_time) / 1000,
      amount: Number(values.quantity),
      nameOfRequestor: `${userData?.fname} ${userData?.lname}`,
      project: selectedProject?.code,
      fundcode: selectedFundcode?.code!!,
      vehicle: selectedVehicle?.pnumber!!,
      vehicle_id: selectedVehicle?.id!!,
    };

    try {
      setIsLoading(true);
      const response = await requestService.createRequest(data);
      if ([200, 201].includes(response.status)) {
        toast.success(response.data.response, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
        setTimeout(() => {
          navigate(-1);
        }, 5000);
      }
    } catch (e: any) {
      toast.error('Sorry, something went wrong. Call support', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleSupplierChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selection = Number(e.currentTarget.value);
    if (selection === 0) setOpen(true);
    else setOpen(false);
  };
  const submitSupplierForm = async (data: any) => {
    const axios = await apiClient.createSupplier(data);
    const message =
      axios.status == 201
        ? axios.data.response?.message
        : 'Oops! Something went wrong. Please contact support';
    toast.info(message, {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
    setOpen(false);
    loadSuppliers(data.location);
    setSelectedSupplier(axios.data.response?.supplier);
  };
  useEffect(() => {
    if (isAuthenticated()) loadData();
    else navigate('/login', {state: {targetPath: '/requests/fuel/new'}});
  }, [selectedSupplier]);
  return (
    <>
      <div className='w-full flex justify-end items-center bg-gray-100 pe-4'>
        <TopStrip user={userData} />
      </div>
      <main className='w-full flex bg-white min-h-screen'>
        <div className='md:w-2/12 flex flex-col items-start text-center justify-center'>
          <Sidebar
            notificationCount={[].length}
            user={userData}
            active={1}
          />{' '}
          f
        </div>
        <div className='md:w-9/12 mx-auto space-y-4 mt-2'>
          <ToastContainer />
          {open ? (
            <SupplierForm
              onSubmit={submitSupplierForm}
              state={open}
              onClose={() => {
                setOpen(false);
              }}
              defaultLocation={
                selectedDriver ? selectedDriver.location : 'Dar es salaam'
              }
            />
          ) : null}

          <Formik
            validationSchema={formValidationSchema}
            initialValues={{
              supplier: '',
              required_date: '',
              price: 0,
              requestor: userData?.id,
              mileage: selectedVehicle?.current_mileage,
              quantity: '',
              destination: '',
              destination_city: userData?.location,
              start_time: '',
            }}
            onSubmit={formHandler}>
            {({handleSubmit, handleChange, values, errors, touched}) => (
              <form
                name='vehicle-request-form'
                id='vehicle-request-form'
                className='center-self border-all-main'
                onSubmit={handleSubmit}>
                <p className='text-2xl font-bold my-3 text-start'>
                  Fuel Request
                </p>

                <div className='mt-5 w-100 flex items-center justify-start flex-wrap space-x-2'>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>
                      Requestor's Name <span className='text-red-500'>*</span>
                    </p>
                    {isUserAdmin ? (
                    <Select
                        placeholder="Select Requestor"
                        required
                        className=''
                        name='requestor'
                        id='requestor'
                        onChange={(option: SingleValue<ISelectOption>) => {
                          handleDriverSelect(option);
                        }}
                        options={fRequestors?.map((u) => {
                          return {
                            label: u.fname + ' ' + u.lname,
                            value: u.id!,
                          };
                        })}
                        // defaultValue={{
                        //   label: selectedDriver?.fname + ' ' + selectedDriver?.lname,
                        //   value: selectedDriver?.id!,
                        // }}
                      />
                    ) : (
                      <Select
                        required
                        isDisabled
                        name='requestor'
                        id='requestor'
                        options={[
                          {
                            label: userData?.fname + ' ' + userData?.lname,
                            value: userData?.id,
                          },
                        ]}
                        defaultValue={{
                          label: userData?.fname + ' ' + userData?.lname,
                          value: userData?.id,
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className='mt-5 w-100 flex items-center justify-start flex-wrap space-x-2'>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>
                      Select Vehicle <span className='text-red-500'>*</span>
                    </p>
                    <Select
                      required
                      className=''
                      name='vehicle'
                      id='vehicle'
                      onChange={(option: SingleValue<ISelectOption>) => {
                        handleVehicleChange(option);
                      }}
                      options={fVehicles.map((v) => {
                        return {
                          label: v.pnumber + ' - ' + v.brand + ' ' + v.model,
                          value: v.id,
                        };
                      })}
                      //   defaultValue={{label: selectedVehicle?.pnumber , value: selectedVehicle?.id}}
                    />
                    <small className='text-red-500'>
                      {!selectedVehicle ? 'Please select a vehicle' : null}
                    </small>
                  </div>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>Vehicle Mileage</p>
                    <input
                      disabled
                      onChange={handleChange}
                      className='form-control '
                      type='text'
                      name='mileage'
                      id='mileage'
                      defaultValue={selectedVehicle?.current_mileage}
                      placeholder='Enter vehicle mileage'
                    />
                  </div>
                </div>
                <div className='mt-5 w-100 flex items-start justify-start space-x-2'>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>
                      Required Date <span className='text-red-500'>*</span>
                    </p>
                    <input
                      className='form-control w-50'
                      type='date'
                      name='required_date'
                      id='required_date'
                      onChange={handleChange}
                      onFocus={handleFocus}
                    />
                    <small className='text-red-500'>
                      {errors && errors.required_date && touched
                        ? errors.required_date
                        : null}
                    </small>
                  </div>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>Time</p>
                    <input
                      onChange={handleChange}
                      className='form-control'
                      type='time'
                      name='start_time'
                      id='start_time'
                    />
                  </div>
                </div>

                <div className='mt-5 w-100 flex items-start justify-start flex-wrap space-x-2'>
                  <div className='text-start w-4/12'>
                    <p className='text-textDefault'>
                      Select Supplier <span className='text-red-500'>*</span>
                    </p>
                    <select
                      className='form-control '
                      name='supplier'
                      id='supplier'
                      onChange={(e) => {
                        handleChange(e);
                        handleSupplierChange(e);
                      }}
                      defaultValue={values.supplier}>
                      <option>--</option>
                      {suppliers &&
                        suppliers.map((v) => {
                          return (
                            <option
                              key={v.id}
                              value={v.id}>
                              {v.name}
                            </option>
                          );
                        })}
                      <option
                        value={0}
                        className='text-2xm'>
                        -- add new supplier --
                      </option>
                    </select>
                    <small className='text-red-500'>
                      {errors && errors.supplier && touched
                        ? errors.supplier
                        : null}
                    </small>
                  </div>
                  <div className='text-start w-3/12'>
                    <p className='text-textDefault'>
                      Unit Price (TSH) <span className='text-red-500'>*</span>
                    </p>
                    <input
                      onChange={handleChange}
                      className='form-control '
                      type='number'
                      name='price'
                      id='price'
                      defaultValue={values.price}
                      placeholder='Enter unit price in TSH'
                    />
                    <small className='text-red-500'>
                      {errors && errors.price && touched ? errors.price : null}
                    </small>
                  </div>
                  <div className='text-start w-3/12'>
                    <p className='text-textDefault'>
                      Quantity (Liters) <span className='text-red-500'>*</span>
                    </p>
                    <input
                      onChange={handleChange}
                      className='form-control '
                      type='number'
                      name='quantity'
                      id='quantity'
                      defaultValue={values.quantity}
                      placeholder='Enter quantity in Ltrs'
                    />
                    <small className='text-red-500'>
                      {errors && errors.quantity && touched
                        ? errors.quantity
                        : null}
                    </small>
                  </div>
                </div>

                <div className='mt-5 w-100 flex items-start justify-start flex-wrap space-x-2'>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>
                      Project <span className='text-red-500'>*</span>
                    </p>
                    <Select
                      required
                      onChange={(e: any) => {
                        handleProjectChange(e);
                      }}
                      className=''
                      name='project'
                      id='project'
                      options={projects.map((project: IProjectDetail) => {
                        return {
                          value: project.code,
                          label: project.code,
                        };
                      })}
                    />
                    <small className='text-red-500'>
                      {!selectedProject ? 'Please select a project' : null}
                    </small>
                  </div>
                  <div className='text-start w-5/12'>
                    <p className='text-textDefault'>
                      Fund Code <span className='text-red-500'>*</span>
                    </p>
                    <Select
                      required
                      id='fundcode'
                      name='fundcode'
                      className=''
                      onChange={(e: any) => {
                        handleFundcodeChange(e);
                      }}
                      options={fundcodes.map((fundcode: Fundcode) => {
                        return {
                          value: fundcode.code,
                          label: fundcode.code,
                        };
                      })}
                    />
                    <small className='text-red-500'>
                      {!selectedFundcode ? 'Please select a fund code' : null}
                    </small>
                  </div>
                </div>
                <div className='mt-5 text-start w-10/12'>
                  <p className='text-textDefault'>Activities</p>
                  <div className='w-10/12 flex justify-start items-center space-x-2'>
                    {activities?.map((a) => {
                      return (
                        <span
                          key={'lb' + a}
                          className='flex justify-start items-center p-2'>
                          <input
                            className='w-100 '
                            type='checkbox'
                            id={'cb' + a}
                            value={a}
                            onChange={handleChange}
                          />
                          <span className='ms-1'>{a}</span>
                        </span>
                      );
                    })}
                  </div>
                </div>

                <div className='mt-5 w-100 flex items-center justify-even flex-wrap space-x-3'>
                  <div className='text-start w-3/12'>
                    <p className='text-textDefault'>Account</p>
                    <input
                      className='form-control '
                      type='text'
                      name='account'
                      id='account'
                      placeholder='Account'
                      onChange={handleChange}
                    />
                  </div>

                  <div className='text-start w-3/12'>
                    <p className='text-textDefault'>Source</p>
                    <input
                      id='source'
                      name='source'
                      className='form-control'
                      placeholder='Source'
                      onChange={handleChange}
                    />
                  </div>
                  <div className='text-start w-3/12'>
                    <p className='text-textDefault'>Category</p>
                    <input
                      id='category'
                      className='form-control'
                      name='category'
                      placeholder='Category'
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className='mt-5 flex justify-between items-center w-10/12'>
                  {isLoading ? (
                    <Spinner className='spinner-sm mt-4' />
                  ) : (
                    <button
                      type='submit'
                      id='submit'
                      name='submit'
                      className=' bg-accent p-2 text-center hover:bg-accentDark'>
                      Submit
                    </button>
                  )}
                  <button
                    type='button'
                    className='bg-transparent border border-accent text-accent p-2 text-center'
                    onClick={() => {
                      navigate('/requests');
                    }}>
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </main>
    </>
  );
};
export default FuelRequestForm;
